import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from 'react-icons/fa';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Button, Grid, Typography } from '@tq/ui-components';

import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { Report } from 'types';

type ReportCardProps = {
  report: Report;
  runReport: () => void;
};

export const ReportCard: React.FC<ReportCardProps> = ({ report, runReport }) => {
  const { t } = useTranslation('reports');
  const isMobile = useIsMobile();

  return (
    <Box
      border={`1px solid ${COLOURS.gray[300]}`}
      borderRadius={5}
      p={4}
      boxShadow='0 0 12px -8px rgba(0, 0, 0, 0.35)'
      data-testid={report.header.toLowerCase().replace(' ', '-') + '-card'}
    >
      <Box height='150px'>
        <Grid height='100%'>
          <Box>
            <Typography>
              <h2>{report.header}</h2>
            </Typography>
            <Typography fontSize='sm' lineHeight='20px' mt={2}>
              {report.description}
            </Typography>
          </Box>
          <Button
            size={isMobile ? 'md' : 'sm'}
            variant='secondary'
            alignSelf='end'
            rightIcon={<FaArrowRight />}
            onClick={runReport}
          >
            {t('run_report', 'Run report')}
          </Button>
        </Grid>
      </Box>
    </Box>
  );
};
